const CryptoJS = require("crypto-js");
let base = {
	shareLogo: process.env.VUE_APP_SHARE_URL.replace("/#/", "") + '/img/logo.jpg',
}

const shareWeiXin = (res, title, description, locationURL, imgUrl) => {
	description = '读懂农民 读懂中国'
	if (!imgUrl) {
		imgUrl = base.shareLogo
	}
	let shareUrl = locationURL.indexOf('?') > -1 ? locationURL + "&tencentShare=1" : locationURL + "?tencentShare=1";
	let timestamp = Date.now()
	let sha10riginal = `jsapi_ticket=${res.data.ticket}&noncestr=taiji123&timestamp=${timestamp}&url=${locationURL}`
	let signature = CryptoJS.SHA1(sha10riginal).toString().toLowerCase();
	// wx.config({
	// 	debug: false,
	// 	appId: 'wx4ada907f7c28e1a5', // 必填，公众号的唯一标识
	// 	timestamp: timestamp, // 必填，生成签名的时间戳
	// 	nonceStr: 'taiji123', // 必填，生成签名的随机串
	// 	signature: signature, // 必填，签名，见附录1
	// 	openTagList: ['wx-open-launch-app'], // 声明使用微信开放标签
	// });


	setShareInfo({
		title: title,
		summary: description,
		pic: imgUrl,
		url: shareUrl,
		WXconfig: {
			swapTitleInWX: false, //swapTitleWX必须false，否则，微信朋友圈分享标题会被summary覆盖
			appId: 'wx4ada907f7c28e1a5',
			timestamp: timestamp,
			nonceStr: 'taiji123',
			signature: signature
		}
	});


	window["setShareInfo"] = {
		title: title,
		summary: description,
		pic: imgUrl,
		url: shareUrl,
	}
};

export default {
	shareWeiXin
}